import { Network } from 'nftx.js';
import { arbitrum, mainnet, sepolia, base } from 'viem/chains';

export const normalizeChainSlug = (chain: string | number) => {
  switch (chain) {
    case 'arb':
    case 'arbitrum':
    case '42161':
    case 42_161:
      return 'arb';
    case 'sepolia':
    case '11155111':
    case 11_155_111:
      return 'sepolia';
    case 'base':
    case '8453':
    case 8_453:
      return 'base';
    case 'mainnet':
    case 'eth':
    case '1':
    default:
      return 'eth';
  }
};

// when we mount the app, we want to calculate the Network based on the chain route param
// and use that to drive the provider / wagmi / nftxjs config
export const getNetworkFromChainSlug = (chain: string) => {
  switch (normalizeChainSlug(chain)) {
    case 'sepolia':
      return Network.Sepolia;
    case 'arb':
      return Network.Arbitrum;
    case 'base':
      return Network.Base;
    case 'eth':
    default:
      return Network.Mainnet;
  }
};

export const getChainFromSlug = (chain: string) => {
  switch (normalizeChainSlug(chain)) {
    case 'arb':
      return arbitrum;
    case 'sepolia':
      return sepolia;
    case 'base':
      return base;
    case 'eth':
    default:
      return mainnet;
  }
};
